import { Box, Skeleton, Typography } from '@mui/material';
import {FC, useState} from 'react';

type Props = {
  url: string;
  alt: string;
};

const ImagePreviewer:FC<Props> = ({ url, alt }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);


  const handleImageLoad = () => {
    setIsLoading(false);
  };

  const handleImageError = () => {
    setIsLoading(false);
    setHasError(true);
  };

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      maxHeight: '80vh',
    }}>
      {isLoading && !hasError && (
        <Skeleton
          variant="rectangular"
          width="100%"
          height="300px"
          sx={{
            borderRadius: "16px"
          }}
        />
      )}

      {hasError && (
        <Typography color="error" variant="body2">
          Failed to load image preview
        </Typography>
      )}

      <img
        src={url}
        alt={alt}
        onLoad={handleImageLoad}
        onError={handleImageError}
        style={{
          maxWidth: '100%',
          maxHeight: '80vh',
          objectFit: 'contain',
          display: isLoading || hasError ? 'none' : 'block',
          borderRadius: "16px"
        }}
      />
    </Box>
  );
};

export default ImagePreviewer;